let privateRoutes = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import(  '../views/Dashboard.vue')
    }
];
import UtilitiesRoutes from "../../../vendor/hitech-informatica/utilities/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(UtilitiesRoutes);
import DataBasesRoutes from "../../../vendor/hitech-informatica/data-bases-rmc/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(DataBasesRoutes);
import ForumRoutes from "../../../vendor/hitech-informatica/forum/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(ForumRoutes);
import RolesRoutes from "../../../vendor/hitech-informatica/roles/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(RolesRoutes);
import ProfessionalsRoutes from "../../../vendor/hitech-informatica/professionals/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(ProfessionalsRoutes);
import AgreementsRoutes from "../../../vendor/hitech-informatica/agreements/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(AgreementsRoutes);
import AdditionalInformationRoutes from "../../../vendor/hitech-informatica/additional-information/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(AdditionalInformationRoutes);
import VideosRoutes from "../../../vendor/hitech-informatica/videos/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(VideosRoutes);
import InternalCommunicationsRoutes from "../../../vendor/hitech-informatica/internal-communications/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(InternalCommunicationsRoutes);
import OfficesRoutes from "../../../vendor/hitech-informatica/offices/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(OfficesRoutes);
import VariousDocumentsRoutes from "../../../vendor/hitech-informatica/various-documents/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(VariousDocumentsRoutes);
import DirectContactRoutes from "../../../vendor/hitech-informatica/direct-contact/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(DirectContactRoutes)
//addRouter
export default privateRoutes;
